<template>
  <aside v-if="showFilters" class="channel-filters">
    <HFilterHeader :title="title">
      <WButton
        icon-button
        variant="tertiary"
        size="small"
        icon="icClose"
        @click="closeFilters"
      />
    </HFilterHeader>
    <section class="channel-filters__content">
      <HFilterSection
        v-if="currentStatus.length"
        id="status"
        icon="icCheckOutlined"
        title="Status"
      >
        <HSelectTags
          placeholder="Selecione os status"
          :options="currentStatus"
          :values="selectedStatus"
          select-value-label="name"
          @input="handleSelectStatus"
        />
      </HFilterSection>
      <HFilterSection id="tag" icon="icMenuSquare" title="Tags">
        <LoadingComponent
          v-if="loading"
          :loading="loading"
          class="channel-filters__loading"
        />
        <HSelectTags
          v-else
          placeholder="Selecione as tags"
          :options="currentTags"
          :values="selectedTags"
          select-value-label="name"
          @input="handleSelectTag"
        />
      </HFilterSection>
    </section>
    <HFilterFooter @clear="clearFilters" @apply="applyFilters" />
  </aside>
</template>

<script>
import { WButton } from '@alice-health/wonderland-vue'
import { mapState } from 'vuex'

import { LoadingComponent } from '@/components/shared/atoms'
import {
  HFilterFooter,
  HFilterHeader,
  HFilterSection
} from '@/components/shared/atoms/filter'
import { HSelectTags } from '@/components/shared/molecules'
import { CHANNEL_KINDS, chatStatusFilters } from '@/models/channels'

export default {
  components: {
    HFilterHeader,
    HFilterSection,
    HFilterFooter,
    WButton,
    HSelectTags,
    LoadingComponent
  },
  props: {
    title: {
      type: String,
      required: true
    },
    kind: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedTags: [],
      selectedStatus: [],
      loading: false
    }
  },
  computed: {
    ...mapState('ui/channel', ['showFilters']),
    ...mapState('channel', ['tags']),
    currentTags() {
      return this.tags.map(tag => ({
        ...tag,
        selected: this.selectedTags.some(item => item.id === tag.id)
      }))
    },
    currentStatus() {
      const statusFilters =
        this.kind === CHANNEL_KINDS.CHAT ? chatStatusFilters : []
      return statusFilters.map(status => ({
        ...status,
        selected: this.selectedStatus.some(item => item.id === status.id)
      }))
    }
  },
  watch: {
    showFilters(value) {
      if (value) {
        this.getTags()
      }
    }
  },
  beforeUnmount() {
    this.$store.dispatch('channel/drawer/clearCurrentFilters')
  },
  methods: {
    closeFilters() {
      this.$store.commit('ui/channel/setFilters', false)
    },
    handleSelectTag(tags) {
      this.selectedTags = tags
    },
    handleSelectStatus(status) {
      this.selectedStatus = status
    },
    clearFilters() {
      this.selectedTags = []
      this.selectedStatus = []
      this.applyFilters()
    },
    applyFilters() {
      const tags = this.selectedTags.map(tag => tag.name)
      const status = [...this.selectedStatus]
      this.$store.commit('channel/drawer/setCurrentFilters', {
        tags,
        status
      })
      this.closeFilters()
    },
    async getTags() {
      this.loading = true
      await this.$store.dispatch('channel/fetchTags')
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.channel-filters {
  background: var(--sys-color-surface-background-light);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  display: grid;
  grid-template-rows: auto 1fr auto;

  &__content {
    overflow: auto;
    padding: var(--filter-header-padding);
  }
  &__loading {
    position: relative;
    display: flex;
    width: 100%;
    padding: var(--gl-spacing-03);
  }
}
</style>
